const focusHandler = (key) => {
  let code = key.keyCode ? key.keyCode : key.which;
  let result = false;
  if (window.innerWidth <= 600) {
    if (code === 13) {
      key.target.blur();
    }
    result = true;
  }
  return result;
};

export default focusHandler;
